import PropTypes from 'prop-types';

const PhoneNumberPropTypes = PropTypes.shape({
  countryCode: PropTypes.string,
  number: PropTypes.string,
});

export default PhoneNumberPropTypes;
